import { render } from "./userFav.vue?vue&type=template&id=8c6739fa"
import script from "./userFav.vue?vue&type=script&lang=js"
export * from "./userFav.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__